import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { LayoutDefaultComponent } from './layout.component';
import { LayoutPassportComponent } from './passport';
import { LayoutSidebarComponent } from './sidebar';
import { LayoutNestComponent } from './nest.component';
import { LayoutTopComponent } from './top';
import { WatermarkComponent } from './watermark/watermark.component';

const COMPONENTS = [
  LayoutDefaultComponent,
  LayoutSidebarComponent,
  LayoutPassportComponent,
  LayoutTopComponent,
  LayoutNestComponent,
  WatermarkComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    RouterModule,
    NzGridModule,
    NzTabsModule,
    NzAffixModule,
    NzAlertModule,
    NzInputModule,
    NzButtonModule,
    NzLayoutModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [...COMPONENTS]
})
export class LayoutModule {}
